import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsCommunicationGroup } from "@/models/admin/warrantsCommunicationGroup/warrantsCommunicationGroup"
import { IWarrantsCommunicationGroup } from "@/models/admin/warrantsCommunicationGroup/warrantsCommunicationGroup.types"

/**
 * A single `warrants_communication_group` row as returned by Hasura. Mirrors
 * the generated `Financials_Warrants_Communication_Group` row; kept as a narrow
 * type so the parser only depends on the columns it actually reads.
 */
export type WarrantsCommunicationGroupRaw = {
  id: number
  account_number: string
  status: string
  parent_status: string
  current_priority_level: number
  error_description?: string | null
  created_at: string
  deleted_at?: string | null
}

export const WarrantsCommunicationGroupParser: IParser<
  IWarrantsCommunicationGroup,
  WarrantsCommunicationGroupRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsCommunicationGroup(
        data.id,
        data.account_number,
        data.status,
        data.parent_status,
        data.current_priority_level,
        data.error_description ?? null,
        dayjsUTC(data.created_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
